import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import HistoryEventsFilterboxView from './HistoryEventsFilterboxView';

import {
  setDeviceDocumentFilter,
  setDeviceDocumentColumnFilter,
} from '../../actions/documents';

class HistoryEventsFilterbox extends React.Component {
  render() {
    return (
      <HistoryEventsFilterboxView
        documentSoftenerFilter={this.props.documentSoftenerFilter}
        documentSuperiorFilter={this.props.documentSuperiorFilter}
        setDeviceDocumentFilter={this.props.setDeviceDocumentFilter}
        setDeviceDocumentColumnFilter={this.props.setDeviceDocumentColumnFilter}
        deviceDocument={this.props.deviceDocument}
      />
    );
  }
}

const mapDispatch = dispatch => {
  return {
    setDeviceDocumentFilter: (documentType, name, deviceType) =>
      dispatch(setDeviceDocumentFilter(documentType, name, deviceType)),
    setDeviceDocumentColumnFilter: (documentType, name, deviceType, screenType) =>
      dispatch(setDeviceDocumentColumnFilter(documentType, name, deviceType, screenType)),
  };
};

HistoryEventsFilterbox.propTypes = {
  deviceDocument: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  documentSoftenerFilter: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  documentSuperiorFilter: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  setDeviceDocumentFilter: PropTypes.func.isRequired,
  setDeviceDocumentColumnFilter: PropTypes.func.isRequired,
};

export default connect(null, mapDispatch)(HistoryEventsFilterbox);


// WEBPACK FOOTER //
// ./src/components/HistoryEvents/HistoryEventsFilterbox.js